import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import './pages/Home/Home.css';

import DashboardLayout from './layouts/DashboardLayout';
import SinglePageLayout from './layouts/SinglePageLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminRoute from './components/auth/AdminRoute';
import EditorRoute from './components/auth/EditorRoute';

import Home from './pages/Home/Home';
import Dashboard from './pages/Dashboard';
import Register from './pages/Register';
import Search from './pages/Search';
import UpdateBasic from './pages/update/UpdateBasic';
import UpdateContact from './pages/update/UpdateContact';
import UpdatePersonal from './pages/update/UpdatePersonal';
import UpdateHousing from './pages/update/UpdateHousing';
import UpdateDisability from './pages/update/UpdateDisability';
import UpdateEducation from './pages/update/UpdateEducation';
import UpdateVocational from './pages/update/UpdateVocational';
import UpdateEconomic from './pages/update/UpdateEconomic';
import UpdateAssistance from './pages/update/UpdateAssistance';
import UpdateHome from './pages/update/updateHome';
import UpdateWelfare from './pages/update/UpdateWelfare';
import UpdateRehabilitation from './pages/update/UpdateRehabilitation';
import AnalyticsSelection from './pages/analytics/AnalyticsSelection';
import AnalyticsView from './pages/analytics/AnalyticsView';
import UserManagement from './pages/admin/UserManagement';
import EditUser from './pages/admin/EditUser';
import Documentation from './pages/docs/Documentation';
import PersonalSummary from './pages/PersonalSummary';

function App() {
  return (
    <Routes>
      {/* ===== PUBLIC ROUTES ===== */}
      <Route
        path="/"
        element={
          <SinglePageLayout>
            <Home />
          </SinglePageLayout>
        }
      />

      <Route
        path="/home"
        element={
          <SinglePageLayout>
            <Home />
          </SinglePageLayout>
        }
      />

      {/* ===== PROTECTED ROUTES - Require Login ===== */}
      <Route
        path="/register"
        element={
          <EditorRoute>
            <SinglePageLayout>
              <Register />
            </SinglePageLayout>
          </EditorRoute>
        }
      />

      <Route
        path="/search"
        element={
          <ProtectedRoute>
            <SinglePageLayout>
              <Search />
            </SinglePageLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/analytics/select"
        element={
          <ProtectedRoute>
            <SinglePageLayout>
              <AnalyticsSelection />
            </SinglePageLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/analytics/view"
        element={
          <ProtectedRoute>
            <SinglePageLayout>
              <AnalyticsView />
            </SinglePageLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/summary/:recordId"
        element={
          <ProtectedRoute>
            <SinglePageLayout>
              <PersonalSummary />
            </SinglePageLayout>
          </ProtectedRoute>
        }
      />

      {/* ===== UPDATE ROUTES - Require Login ===== */}
      <Route
        path="/update/basic/:recordId"
        element={
          <ProtectedRoute>
            <UpdateBasic />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/contact/:recordId"
        element={
          <ProtectedRoute>
            <UpdateContact />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/personal/:recordId"
        element={
          <ProtectedRoute>
            <UpdatePersonal />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/housing/:recordId"
        element={
          <ProtectedRoute>
            <UpdateHousing />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/disability/:recordId"
        element={
          <ProtectedRoute>
            <UpdateDisability />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/education/:recordId"
        element={
          <ProtectedRoute>
            <UpdateEducation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/vocational/:recordId"
        element={
          <ProtectedRoute>
            <UpdateVocational />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/economic/:recordId"
        element={
          <ProtectedRoute>
            <UpdateEconomic />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/assistance/:recordId"
        element={
          <ProtectedRoute>
            <UpdateAssistance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/home/:recordId"
        element={
          <ProtectedRoute>
            <UpdateHome />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/welfare/:recordId"
        element={
          <ProtectedRoute>
            <UpdateWelfare />
          </ProtectedRoute>
        }
      />
      <Route
        path="/update/rehabilitation/:recordId"
        element={
          <ProtectedRoute>
            <UpdateRehabilitation />
          </ProtectedRoute>
        }
      />

      {/* ===== Doc ROUTES ===== */}
      <Route
        path="/docs"
        element={
          <ProtectedRoute>
            <SinglePageLayout>
              <Documentation />
            </SinglePageLayout>
          </ProtectedRoute>
        }
      />

      {/* ===== ADMIN ROUTES - Dashboard & User Management ===== */}
      <Route
        path="/dashboard"
        element={
          <AdminRoute>
            <DashboardLayout>
              <Dashboard />
            </DashboardLayout>
          </AdminRoute>
        }
      />

      <Route
        path="/admin/users"
        element={
          <AdminRoute>
            <DashboardLayout>
              <UserManagement />
            </DashboardLayout>
          </AdminRoute>
        }
      />

      <Route
        path="/admin/users/edit"
        element={
          <AdminRoute>
            <DashboardLayout>
              <EditUser />
            </DashboardLayout>
          </AdminRoute>
        }
      />

      <Route
        path="/reports"
        element={
          <AdminRoute>
            <DashboardLayout>
              <div>
                <h2>Reports Page</h2>
                <p>Reports coming soon...</p>
              </div>
            </DashboardLayout>
          </AdminRoute>
        }
      />

      <Route
        path="/settings"
        element={
          <AdminRoute>
            <DashboardLayout>
              <div>
                <h2>Settings Page</h2>
                <p>Settings coming soon...</p>
              </div>
            </DashboardLayout>
          </AdminRoute>
        }
      />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
